const customers = [
    {
        id: 1,
        image: 'https://www.karemfouad.com/wp-content/uploads/2020/11/handsome-businessman-in-suit-and-glasses-cross-arms-chest-and-look.jpg.webp',
        opinion: 'هنا يضع رأي العميل بشكل مفصل',
        name: 'اسم العميل',
        job: 'صفة العميل'
    },
    {
        id: 2,
        image: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
        opinion: ' هنا يضع رأي العميل بشكل مفصل',
        name: 'اسم العميل',
        job: 'صفة العميل'
    },
] 

export default customers